export const PRODUCTS_STEP_LIST = [
  'Choose the product below and click "Add to showcase"',
  "Download YooFinds App and request free samples",
  "Post content on TikTok and start making commissions",
];
